import { defineComponent as _defineComponent } from 'vue'
import { BulkDeletableTable } from '@/ui/components/table/BulkDeletableTable';
  import { t, du } from '@/ui/i18n/i18n';
  import { ref, watch } from 'vue';
  import { debounce } from 'lodash';
  import * as qs from '@/ui/queryState';
  import { emptyList } from '@/services/api';
  import { Box } from '@/ui/components/Box';
  import { Loader } from '@/ui/components/Loader';
  import FilterForm from '@/ui/components/filters/horizontal/FilterForm.vue';
  import SearchFilter from '@/ui/components/filters/horizontal/SearchFilter.vue';
  import BulkDeleteButton from '@/ui/components/button/BulkDeleteButton.vue';
  import { Pagination } from '@/ui/components/Pagination';
  import CompletedCoursesEmpty from '@/ui/pages/trainings/tabs/empty/CompletedCoursesEmpty.vue';
  import { usePagination, useTask } from '@/ui/concerns';
  import { useBulkDeletable } from '@/ui/pages/useBulkDeletable';
  import { listCourseReports, bulkDeleteCourseReports, removeCourseReport } from '@/services/api/resources/trainings';
  import type { CourseReportAuthorized, CourseReportsList } from '@/entities/trainings/course-report/model';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompletedCoursesTab',
  setup(__props) {

  const reportsList = ref<CourseReportsList>(emptyList());
  const search = qs.string('q', '');
  const { page, perPage, resetPagination } = usePagination();

  const getReports = useTask(
    () => listCourseReports({
      page: page.value,
      perPage: perPage.value,
      search: search.value,
    }),
    result => {
      reportsList.value = result;
    },
  );

  watch([page, perPage, search], debounce(() => {
    getReports.run();
  }, 100));

  const { selectedResources, deleteBulkTask, onCheckedRowsUpdate, isBulkDeletionDisabled } = useBulkDeletable<CourseReportAuthorized>({
    getList: getReports,
    bulkDeleteFn: bulkDeleteCourseReports,
  });

  const formatResult = (passed: boolean | null) => {
    if (passed === null) {
      return '';
    }

    return passed ? t('trainings.passed') : t('trainings.failed');
  };

  const canDeleteReport = (report: CourseReportAuthorized) => report.authorizedTo.delete;

return { __sfc: true,reportsList, search, page, perPage, resetPagination, getReports, selectedResources, deleteBulkTask, onCheckedRowsUpdate, isBulkDeletionDisabled, formatResult, canDeleteReport, BulkDeletableTable, du, Box, Loader, FilterForm, SearchFilter, BulkDeleteButton, Pagination, CompletedCoursesEmpty, removeCourseReport }
}

})